<template>
  <div>
    <div class="py-3 pl-14 d-flex">
      <div>
        <p class="ma-0 font-24 font-weight-medium">Análise de cotação</p>
        <p class="ma-0 font-12 font-weight-medium">Selecione quais produtos de fornecedores você deseja comprar</p>
      </div>

      <slot name="titulo-lado-direito" />
    </div>

    <v-divider />
  </div>
</template>

<script>
export default {
  name: "TituloDialog",
}
</script>

<style scoped>

</style>
